// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__Ut9Qg","notes":"Notes_notes__3Mfaz"};